import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { IInventoryLocation } from 'src/app/shared/interfaces/inventory-location.interface';
import { InventoryState } from 'src/app/shared/states/inventory/inventory.state';
import { SettingsState } from 'src/app/shared/states/settings/settings.state';

@Component({
  selector: 'app-add-edit-inventory-location-dialog',
  templateUrl: './add-edit-inventory-location-dialog.component.html',
  styleUrls: ['./add-edit-inventory-location-dialog.component.scss']
})
export class AddEditInventoryLocationDialogComponent implements OnInit {

  @Input() header = 'Add Inventory Location';
  @Input() submitButtonText = 'Add Location';

  private _data: IInventoryLocation;

  private locations: IInventoryLocation[];

  @Input() 
  set data(data: IInventoryLocation) {
    if (data) {
      this.header = 'Edit Inventory Location';
      this.submitButtonText = 'Save';
      this.form.get('name')?.setValue(data.name);
      this.form.get('description')?.setValue(data.description);
    }
    this._data = data;
  }

  get data(): IInventoryLocation {
    return this._data;
  }

  @Output() save: EventEmitter<{name: string, description?:string}> = new EventEmitter();
  @Output() cancel: EventEmitter<void> = new EventEmitter();

  @Select(SettingsState.loading) loading$: Observable<boolean>;
  @Select(InventoryState.locations) locations$: Observable<IInventoryLocation[]>;

  form: UntypedFormGroup;
  /**
   *
   */
  constructor(private fb: UntypedFormBuilder, private store: Store) {
    this.form = fb.group({
      name: new FormControl('', [ Validators.required, this.duplicateLocationNameValidator.bind(this)]),
      description: ''
    });
  }
  ngOnInit(): void {
   this.locations$
   .pipe(take(1))
   .subscribe(val => this.locations = val)
  }

  submit(): void {
    const row = this.form.getRawValue();
    this.save.next({name: row.name, description: row.description});
  }

  duplicateLocationNameValidator(control: FormControl): {[s:string]: boolean} | null {
    const inputVal = control?.value?.toLowerCase();
    if (this.locations?.some(x => x?.name?.toLowerCase() === inputVal) && this.data?.name?.toLowerCase() !== inputVal) {
      return { duplicateLocationName : true };
    }
    return null;
  }


}
